import {
  GET_DYNAMIC_PROPERTIES,
  CREATE_DYNAMIC_PROPERTY,
  DYNAMIC_PROPERTY_UPDATED,
} from "../actions/dynamicProperties.actions";

const defaultState = {
  dynamicPropertiesManagement: {
    properties: [],
  },
};

const dynamicPropertiesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_DYNAMIC_PROPERTIES: {
      return {
        dynamicPropertiesManagement: {
          properties: action.payload || [],
          // Preserve existing snackbar if present
          snackbar: state.dynamicPropertiesManagement?.snackbar,
        },
      };
    }
    case CREATE_DYNAMIC_PROPERTY:
      return {
        dynamicPropertiesManagement: {
          properties: state.dynamicPropertiesManagement?.properties || [],
          snackbar: {
            state: true,
            message: "Dynamic Property Created Successfully",
            type: "success",
          },
        },
      };
    case DYNAMIC_PROPERTY_UPDATED: {
      const updatedProperty = action.payload;
      const existingProperties = state.dynamicPropertiesManagement?.properties || [];

      // Find and update the property in the array
      const propertyIndex = existingProperties.findIndex(
        (prop) => prop.key === updatedProperty.key
      );

      let updatedProperties;
      if (propertyIndex >= 0) {
        // Update existing property
        updatedProperties = [...existingProperties];
        updatedProperties[propertyIndex] = updatedProperty;
      } else {
        // Property not found, add it (shouldn't happen, but handle gracefully)
        updatedProperties = [...existingProperties, updatedProperty];
      }

      return {
        dynamicPropertiesManagement: {
          properties: updatedProperties,
          snackbar: {
            state: true,
            message: "Dynamic Property Updated Successfully",
            type: "success",
          },
        },
      };
    }
  }
};

export default dynamicPropertiesReducer;
